<template>
  <!-- 床位类型管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      v-model="tableForm"
      :permission="permissionList"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="imgUrl" slot-scope="{ row }">
        <img
          v-if="row.imgUrl"
          style="width: 60%; height: 50%"
          :src="row.imgUrl"
          @click="previewImg(row.imgUrl)"
        />
        <div v-else></div>
      </template>
      <template slot="imgUrlForm">
        <VUpload
          :disabled="type == 'view'"
          :types="['jpg', 'png']"
          :limit="1"
          :fileList.sync="attachList"
        ></VUpload>
      </template>
      <template slot="bedPriceForm">
        <div class="form-item-extra">
          <moneyInput
            v-model="tableForm.bedPrice"
            :disabled="formType == 'view'"
            placeholder="请输入金额"
            :template="'no'"
            style="width: 100%"
          />
          <span>元/月</span>
        </div>
      </template>
      <template slot="roomPriceForm">
        <div class="form-item-extra">
          <moneyInput
            v-model="tableForm.roomPrice"
            :disabled="formType == 'view' ? true : false"
            placeholder="请输入 金额"
            :template="'no'"
            style="width: 100%"
          />
          <span>元/月</span>
        </div>
      </template>
      <template slot="depositForm">
        <moneyInput
          v-model="tableForm.deposit"
          :disabled="formType == 'view'"
          placeholder="请输入 金额"
          :template="'no'"
          style="width: 100%"
        />
      </template>
      <template slot="effectiveDateForm">
        <el-date-picker
          :readonly="formType == 'view'"
          v-model="tableForm.effectiveDate"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          :picker-options="datePickerOptions"
        ></el-date-picker>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import VUpload from '@/views/components/v-upload';
import { getNursinghomeList } from '../api/public.js';
import { getTypePageListApi, addTypeApi, updateTypeApi, removeTypeApi } from '../api/bedManage';

export default {
  components: {
    VUpload,
  },
  data() {
    return {
      oldNursinghomeId: '', // 旧养老院id，重置搜索条件和新增时需要使用
      nursinghomeList: [], // 养老院列表
      searchForm: {}, // 搜索表单
      tableForm: {}, // crud表单
      formType: '', // curd表单类型
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      // 日期选择组件的选择控制
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      attachList: [], // 图片集合
      listData: [], // 列表数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        dialogClickModal: false,
        searchMenuSpan: 18,
        searchLabelWidth: 100,
        labelWidth: 100,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            disabled: true,
            search: true,
            searchClearable: false,
            rules: [
              {
                required: true,
                message: '请选择服务网点',
                trigger: 'change',
              },
            ],
          },
          {
            label: '类型名称',
            prop: 'name',
            maxlength: '10',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入类型名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '床位月价格',
            prop: 'bedPrice',
            formslot: true,
            rules: [
              {
                required: true,
                message: '请输入床位价格',
                trigger: 'change',
              },
            ],
          },
          {
            label: '包房月价格',
            prop: 'roomPrice',
            formslot: true,
          },
          {
            label: '订金',
            prop: 'deposit',
            formslot: true,
          },
          {
            label: '生效日期',
            prop: 'effectiveDate',
            hide: true,
            showColumn: false,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请选择生效日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '床位描述',
            prop: 'description',
            type: 'textarea',
            span: 24,
            maxlength: '200',
            minRows: 3,
            maxRows: 5,
            showWordLimit: true,
          },
          {
            label: '床位图片',
            prop: 'imgUrl',
            slot: true,
            formslot: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.bed_type_add, false),
        editBtn: this.vaildData(this.permission.bed_type_edit, false),
        delBtn: this.vaildData(this.permission.bed_type_delete, false),
      };
    },
  },
  watch: {
    attachList(val) {
      if (val.length > 0) {
        this.tableForm.imgUrl = val[0].link;
      } else {
        this.tableForm.imgUrl = '';
      }
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.findObject(this.tableOption.column, 'nursinghomeId').dicData = this.nursinghomeList;
        this.searchForm.nursinghomeId = this.nursinghomeList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 330; // 表格区域初始化高度
      const searchH = 57; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    loadData(page) {
      if (this.nursinghomeList.length == 0) return; // 在获取到养老院列表前不要请求列表
      this.oldNursinghomeId = this.searchForm.nursinghomeId;
      page = page || this.tablePage;
      this.loading = true;
      getTypePageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        nursinghomeId: this.oldNursinghomeId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    beforeOpenForm(done, type) {
      this.needCloseConfirm = true;
      this.formType = type;
      if (type == 'add') {
        this.tableForm = {
          nursinghomeId: this.oldNursinghomeId,
        };
        this.attachList = [];
      } else {
        let imgUrl = this.tableForm.imgUrl;
        if (imgUrl) {
          // 组件里要求必须传originalName字段
          let arr = imgUrl.split('/');
          let originalName = arr[arr.length - 1];
          this.attachList = [{ link: imgUrl, originalName }];
        } else {
          this.attachList = [];
        }
        if (type == 'view') {
          this.needCloseConfirm = false;
        }
      }
      done();
    },
    beforeCloseForm(done, type) {
      if (!this.needCloseConfirm) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          done();
        });
      }
    },
    rowSave(row, done, loading) {
      addTypeApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      updateTypeApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeTypeApi({
            ids: row.id,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
    /* 预览图片 */
    previewImg(imgUrl) {
      this.$ImagePreview([{ thumbUrl: imgUrl, url: imgUrl }], 0);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 表单弹框-输入框后面有附加信息的 */
.form-item-extra {
  display: flex;
  align-items: center;
  span {
    white-space: nowrap;
    margin-left: 10px;
  }
}
</style>
